<script setup lang="ts">
import circle from "@/assets/img/loading-circle.png"
import unicorn from "@/assets/img/loading-unicorn.png"

export interface Props {
  full?: boolean
}

withDefaults(defineProps<Props>(), {
  full: false,
})
</script>

<template>
  <div
    id="appLoading"
    role="status"
    :aria-label="$t('accessibility.loading')"
    :class="[
      'relative flex h-full w-full items-center justify-center',
      full && 'fixed inset-0 z-9999 h-screen w-screen bg-white',
    ]"
  >
    <div class="h-32 w-32 animate-spin">
      <img
        :src="circle"
        alt=""
        class="absolute top-1/2 left-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2"
      />
    </div>
    <img
      :src="unicorn"
      alt=""
      class="absolute top-1/2 left-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2"
    />
  </div>
</template>
